import styled from 'styled-components'
import { media } from 'Config/styled'

export const Title = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.5rem;
  margin-bottom: 1.5rem;
  margin-left: 1.25rem;

  ${media('lg')} {
    font-size: 20px;
    line-height: 10px;
    margin-bottom: 20px;
  }
`

export const ProductCardLoadingContainer = styled.div`
  margin: 0 0.6rem 1.5rem;
`
